export enum PAGES {
	HOME = 'fees',
}

/**
 * The Fees admin's Module Federation remote: its federation name, and where Engine serves its
 * manifest from — Engine's own bucket, under remotes/fees/, which motorway/mw-fees-admin's
 * deploy workflow writes to.
 *
 * The manifest's URL never changes, so the deploy must upload mf-manifest.json and
 * remoteEntry.js with `Cache-Control: no-cache`; everything they point at is fingerprinted.
 */
export const REMOTE = {
	NAME: 'fees',
	MANIFEST_PATH: '/remotes/fees/mf-manifest.json',
} as const;

/**
 * The fee service's own address. SDUI Admin reaches mw-sdui through the gateway on BACKEND_URL,
 * but mw-fees has no gateway route: Fees calls it directly, and the API lets Engine's origins in
 * (CORS). Prod Engine uses prod; every other Engine (staging, review apps, local) uses stage.
 */
export const FEES_API_URL = {
	PROD: 'https://mw-fees.dealer.prod.motorway.cloud',
	STAGE: 'https://mw-fees.dealer.stage.motorway.cloud',
} as const;
